import { SessionState } from "./SessionState";
import { UserDirectory } from "./UserDirectory";
import { AvatarCache } from "./AvatarCache";

export type StateLayerDeps = {
  sessionState: SessionState;
  userDirectory?: UserDirectory;
  avatarCache?: AvatarCache;
};

export type StateServices = {
  sessionState: SessionState;
  userDirectory: UserDirectory;
  avatarCache: AvatarCache;
};

let state_services: StateServices | null = null;

function buildStateServices(deps: StateLayerDeps): StateServices {
  const sessionState = deps.sessionState;
  const userDirectory = deps.userDirectory ?? new UserDirectory(sessionState);
  const avatarCache = deps.avatarCache ?? new AvatarCache();
  return { sessionState, userDirectory, avatarCache };
}

export function initializeStateLayer(deps: StateLayerDeps): StateServices {
  if (state_services) {
    throw new Error("State layer already initialized. Call initializeStateLayer only once.");
  }
  state_services = buildStateServices(deps);
  return state_services;
}

export const stateServices: StateServices = {
  get sessionState() {
    if (!state_services) {
      throw new Error("State layer not initialized. Call initializeStateLayer() first.");
    }
    return state_services.sessionState;
  },
  get userDirectory() {
    if (!state_services) {
      throw new Error("State layer not initialized. Call initializeStateLayer() first.");
    }
    return state_services.userDirectory;
  },
  get avatarCache() {
    if (!state_services) {
      throw new Error("State layer not initialized. Call initializeStateLayer() first.");
    }
    return state_services.avatarCache;
  },
};
